import React from 'react';
import {IMatchPairQuestion, IElementQuestionMatchPair} from '../../../../incase-domain/elements/question/questionMatchPair';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {getBorderStyle} from '../../../../utils/style.utils';

interface Pair {
    leftSelectedElement: string;
    rightSelectedElement: string;
}

function MatchPairQuestionItems(props: IQuestionElementProps<IElementQuestionMatchPair>): JSX.Element | null {
    const {element, device} = props;
    const {fontSize: answerFontSize, borderRadius, fontFamily} = element;

    const generateColumn = (items: IMatchPairQuestion[], position: keyof Pair): JSX.Element => {
        const answerDataClass =
            position === 'leftSelectedElement'
                ? 'c-matchPairQuestionElement__answer_data--left'
                : 'c-matchPairQuestionElement__answer_data--right';

        const textClass =
            position === 'leftSelectedElement' ? 'c-matchPairQuestionElement__text--left' : 'c-matchPairQuestionElement__text--right';

        return (
            <div className="c-matchPairQuestionElement__answer">
                {items
                    .filter((item, index, self) => self.findIndex((t) => t.text === item.text) === index)
                    .map((item) => {
                        return (
                            <div
                                key={item.id}
                                className={`c-matchPairQuestionElement__answer_data ${answerDataClass}`}
                                style={{
                                    fontSize: `${answerFontSize || 'initial'}em`,
                                    borderRadius: getBorderStyle(borderRadius),
                                    fontFamily: fontFamily?.name,
                                }}
                            >
                                <input type="radio" id={item.id} name={position} className="c-matchPairQuestionElement__radio" disabled />
                                <button type="button" className={`c-matchPairQuestionElement__text ${textClass}`}>
                                    {item.text}
                                </button>
                            </div>
                        );
                    })}
            </div>
        );
    };

    return (
        <div className={`c-matchPairQuestionElement ${device === DeviceType.MOBILE ? 'c-matchPairQuestionElement--mobile' : ''}`}>
            {generateColumn(element.leftElement, 'leftSelectedElement')}
            {generateColumn(element.rightElement, 'rightSelectedElement')}
        </div>
    );
}

export default MatchPairQuestionItems;
